import { Tag, X } from 'lucide-react'
import { cn } from '@/utils/cn'
import { PAGE_TOOLBAR } from '@/components/ui/page-toolbar'

const fieldClass =
  'w-full rounded-lg border border-[var(--glass-border)] bg-[var(--glass-bg)] px-3 py-2 text-sm text-text-primary outline-none focus:border-accent/50'

type Option = { value: string; label: string }

type Props = {
  open: boolean
  onClose: () => void
  onClearAll: () => void
  taskType: string
  taskTypeOptions: Option[]
  onTaskTypeChange: (value: string) => void
  onApply: () => void
  loading?: boolean
}

export function GestorDashboardFiltersPanel({
  open,
  onClose,
  onClearAll,
  taskType,
  taskTypeOptions,
  onTaskTypeChange,
  onApply,
  loading = false,
}: Props) {
  if (!open) return null

  return (
    <>
      <div className='fixed inset-0 z-40 bg-black/40 md:hidden' aria-hidden onClick={onClose} />
      <div
        role='dialog'
        aria-label='Filtros do dashboard'
        className={cn(
          'z-50 rounded-xl border border-[var(--glass-border)] bg-[var(--bg-card)] p-4 shadow-2xl',
          'fixed inset-x-4 bottom-4 max-h-[70vh] overflow-y-auto md:absolute md:inset-auto md:right-0 md:top-full md:mt-2 md:w-80',
        )}
      >
        <div className='mb-4 flex items-center justify-between'>
          <h3 className='text-sm font-semibold text-text-primary'>Filtros avançados</h3>
          <button
            type='button'
            onClick={onClose}
            className='flex h-8 w-8 items-center justify-center rounded-lg text-text-muted hover:bg-white/[0.06] hover:text-text-primary'
            aria-label='Fechar filtros'
          >
            <X size={16} />
          </button>
        </div>

        <label className='flex flex-col gap-1.5'>
          <span className='flex items-center gap-1.5 text-xs font-medium text-text-muted'>
            <Tag size={13} aria-hidden />
            Tipo de tarefa
          </span>
          <select
            value={taskType}
            onChange={(e) => onTaskTypeChange(e.target.value)}
            className={fieldClass}
          >
            <option value=''>Todos os tipos</option>
            {taskTypeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <div className='mt-4 flex gap-2 border-t border-[var(--glass-border)] pt-4'>
          <button
            type='button'
            onClick={onClearAll}
            className={cn(PAGE_TOOLBAR.clearButton, 'flex flex-1 justify-center sm:flex')}
          >
            Limpar tudo
          </button>
          <button
            type='button'
            disabled={loading}
            onClick={onApply}
            className='flex-1 rounded-lg bg-accent px-3 py-2 text-sm font-medium text-white transition-all hover:opacity-90 disabled:opacity-50'
          >
            Aplicar
          </button>
        </div>
      </div>
    </>
  )
}
